/**
 * @description HeatmapPeriod component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/HeatmapPeriod
 */

import React from 'react';
import PropTypes from 'prop-types';

import HeatmapPeriodTableCell from './HeatmapPeriodTableCell';

/**
 * @description The HeatmapPeriod component.
 * @class 
 * @extends {React.Component}
 */
class HeatmapPeriod extends React.Component {

    /**
     * @inheritdoc
     */
    shouldComponentUpdate(nextProps) {
        return (
            JSON.stringify(this.props.links) !==
                JSON.stringify(nextProps.links) ||
            JSON.stringify(this.props.period) !==
                JSON.stringify(nextProps.period) ||
            this.props.totalDistance !== nextProps.totalDistance ||
            this.props.showTimeBins !== nextProps.showTimeBins
        );
    }

    /**
     * @inheritdoc
     */
    render() {
        return this.props.period.isVisible && (
            <div className="HeatmapPeriod" ref={this.domContainer}>
                <div className="HeatmapPeriod-timeframe">
                    {this.props.period.timeframe}
                </div>
                {this.props.period.journeyTimes ? (
                    this.props.period.journeyTimes
                        .filter(journeyTime =>
                            this.props.links.find(
                                visibleLink => visibleLink.id === journeyTime.linkId
                            )
                        )
                        .map((journeyTime, index) => (
                            <HeatmapPeriodTableCell
                                key={index}
                                isLatest={this.props.isLatest}
                                timeframe={this.props.period.timeframe}
                                journeyTime={journeyTime}
                                index={index}
                                count={this.props.period.journeyTimes.length}
                                totalDistance={this.props.totalDistance}
                                links={this.props.links}
                                openTooltip={this.props.openTooltip}
                                closeTooltip={
                                    this.props.closeTooltip
                                }
                                showTimeBins={this.props.showTimeBins}
                            ></HeatmapPeriodTableCell>
                        ))
                ) : (
                    <div className="HeatmapPeriod-empty-row"></div>
                )}
            </div>
        );
    }
}

HeatmapPeriod.defaultProps = {
    isLatest: false,
    period: {},
    totalDistance: 0,
    showTimeBins: true,
    links: [],
    openTooltip: () => null,
    closeTooltip: () => null
};

HeatmapPeriod.propTypes = {
    period: PropTypes.object.isRequired,
    totalDistance: PropTypes.number.isRequired,
    isLatest: PropTypes.bool.isRequired,
    showTimeBins: PropTypes.bool.isRequired,
    links: PropTypes.array.isRequired,
    openTooltip: PropTypes.func.isRequired,
    closeTooltip: PropTypes.func.isRequired
};

export default HeatmapPeriod;
